module.exports = __webpack_public_path__ + "img/tu17.75dadc22.jpg";